// src/store/useAppConfigStore.js
import { create } from "zustand";

const extractIanaTimezone = (timezoneName, timezoneStr) => {
  if (timezoneName) {
    const match = String(timezoneName).match(/\(([A-Za-z_]+\/[A-Za-z_]+)\)/);
    if (match) return match[1];
    if (String(timezoneName).includes("/")) return String(timezoneName).trim();
  }
  if (typeof timezoneStr === "string" && timezoneStr.includes("/")) {
    return timezoneStr.trim();
  }
  return null;
};

const useAppConfigStore = create((set) => ({
  firstDayOfWeek: "monday",
  dateFormat: "DD MM YYYY",
  dateSeparator: "-",
  currencyFormat: "1,234,567.89",
  decimalPlaces: 2,
  country: "",
  timezone: null,
  timezoneName: null,
  timezoneIana: null,
  language: null,
  financialYear: null,

  setAppConfig: (config) => {
    const tzName = config.timezone_name || (typeof config.timezone === "string" ? config.timezone : null);
    const tzIana = extractIanaTimezone(config.timezone_name, config.timezone);

    const newState = {
      firstDayOfWeek: config.first_day_of_the_week || "monday",
      dateFormat: config.date_format || "DD MM YYYY",
      dateSeparator: config.date_separator || "-",
      currencyFormat: config.currency_format || "1,234,567.89",
      decimalPlaces: config.decimal_places ?? 2,
      country: config.country || "",
      timezone: config.timezone || null,
      timezoneName: tzName,
      timezoneIana: tzIana,
      language: config.language || null,
      financialYear: config.financial_year || null,
    };
    set(newState);
  },

  resetAppConfig: () =>
    set({
      firstDayOfWeek: "monday",
      dateFormat: "DD MM YYYY",
      dateSeparator: "-",
      currencyFormat: "1,234,567.89",
      decimalPlaces: 2,
      country: "",
      timezone: null,
      timezoneName: null,
      timezoneIana: null,
      language: null,
      financialYear: null,
    }),
}));

export default useAppConfigStore;
